import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import SecureLS from 'secure-ls'

import auth from './modules/auth'
import user from './modules/user'

var ls = new SecureLS({
  encodingType: "aes",
  isCompression: true,
  encryptionSecret: "LuIEpuIYx__uiQlMDh1y_mlzDSm9gB4G9ayUtoRS0BhzWmf7IgpwEEbYV3vciLpw"
});


export default createStore({
  namespaced: true,
  modules: {
    auth,
    user,
  },
  plugins: [
    createPersistedState({
      key: 'vertex_core',
      storage: {
        getItem: (key) => {
          try {
            const storedState = ls.get('vertex_core'); // Get the stored Vuex state
            return storedState ? storedState[key] || null : null;
          } catch (error) {
            console.warn("Error retrieving stored state.", error);

            // Handle old compression issues or invalid JSON
            if (
              error.message.includes('Malformed UTF-8') ||
              error.message.includes('Unexpected token') ||
              error.message.includes('Could not parse JSON')
            ) {
              console.warn("Detected corrupted storage. Clearing local storage.");
              localStorage.clear(); // Reset the corrupted storage
              return null;
            }

            throw error; // Re-throw for debugging
          }
        },
        setItem: (key, value) => {
          try {
            const storedState = ls.get('vertex_core') || {};
            storedState[key] = value;
            ls.set('vertex_core', storedState);
          } catch (error) {
            console.error(`Failed to set storage item: ${key}`, error);
          }
        },
        removeItem: (key) => {
          try {
            const storedState = ls.get('vertex_core') || {};
            delete storedState[key];
            ls.set('vertex_core', storedState);
          } catch (error) {
            console.error(`Failed to remove storage item: ${key}`, error);
          }
        },
      },
    }),
  ],
});